import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { DateTime } from "luxon";
import IconSchema from "../../components/icons/IconSchema";
import IconCopyUrl from "../../components/icons/IconCopyUrl";
import IconAddPerson from "../../components/icons/IconAddPerson";
import IconArrow from "../../components/icons/IconArrow";
import ConversationParticipants from "./ConversationParticipants";
import useConversationStats from "../conversations-creator-canvas/useConversationStats";

function copyStudentLink(hashCode) {
    const text = `https://games.english-from-zero.ovh/start?type=1&id=${hashCode}`;
    navigator.clipboard?.writeText(text).catch(() => {});
}

export default function ConversationTile({ conversation, isUsed }) {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const { stats } = useConversationStats(conversation.id);

    return (
        <div className="conversation-plate grid-plate-item conv-tile">
            <div className="grid-plate-header">
                <p className="txt-c grid-plate-name">{conversation.name}</p>
                <p className="secondary-txt txt-c">{conversation.level ? conversation.level.name : ""}</p>
            </div>

            <div className="conv-tile-badges">
                <span className={`conv-badge ${conversation.isPublic === 1 ? "conv-badge-published" : "conv-badge-draft"}`}>
                    {conversation.isPublic === 1 ? "Опубліковано" : "Чернетка"}
                </span>
                {conversation.estimationFunction ? <span className="conv-badge conv-badge-function">{conversation.estimationFunction.name}</span> : ""}
                {conversation.stageTypeId ? <span className="conv-badge conv-badge-pipeline">{conversation.stageTypeId.name}</span> : ""}
                <span className={`conv-badge ${isUsed ? "conv-badge-used" : "conv-badge-unused"}`}>
                    {isUsed ? "Проходили" : "Ще не проходили"}
                </span>
            </div>

            {conversation.tags && conversation.tags.length > 0 ? (
                <div className="conv-tile-tags">
                    {conversation.tags.map((tag) => (
                        <span className="conv-tile-tag" key={tag.id}>{tag.name}</span>
                    ))}
                </div>
            ) : ""}

            {stats ? (
                <div className="conv-tile-inline-stats">
                    <span>Розпочали: <b>{stats.startedCount}</b></span>
                    <span>Завершили: <b>{stats.finishedCount}</b></span>
                    {stats.averageScore != null ? (
                        <span>Середній: <b>{stats.averageScore.toFixed(1)} {stats.scoreUnit}</b></span>
                    ) : ''}
                </div>
            ) : ''}

            <div className="grid-plate-body">
                <p className="txt-c grid-plate-description">{conversation.description}</p>
                {conversation.hashCode ? (
                    <p className="txt-c">
                        <span>Код:</span> {conversation.hashCode}
                    </p>
                ) : (
                    ""
                )}
            </div>

            <div className="conv-tile-footer">
                <p className="txt-c timestamp" style={{ margin: 0 }}>
                    {conversation.dAdd ? DateTime.fromISO(conversation.dAdd, { setZone: true }).toFormat("HH:mm dd.MM.yyyy") : ""}
                </p>

                <div className="conv-tile-actions">
                    {conversation.hashCode ? (
                        <div className="conv-tile-action" onClick={() => copyStudentLink(conversation.hashCode)} title="Скопіювати посилання для учня">
                            <IconCopyUrl fillColor="icon-teel" style={{ width: 20, height: 20 }} />
                        </div>
                    ) : (
                        ""
                    )}

                    <div
                        className={`conv-tile-action conv-tile-expand-btn ${isOpen ? "open" : ""}`}
                        onClick={() => setIsOpen((prev) => !prev)}
                        title="Хто проходив цей тест"
                    >
                        <IconAddPerson fillColor="icon-blue" style={{ width: 20, height: 20 }} />
                        <IconArrow
                            fillColor="icon-blue"
                            style={{ width: 12, height: 12, transition: "transform 0.2s ease", transform: isOpen ? "rotate(90deg)" : "none" }}
                        />
                    </div>

                    <div className="conv-tile-action" onClick={() => navigate("/conversations-creator-canvas/" + conversation.id)} title="Відкрити конструктор">
                        <IconSchema fillColor="icon-orange" style={{ width: 20, height: 20 }} />
                    </div>
                </div>
            </div>

            <ConversationParticipants conversationId={conversation.id} isOpen={isOpen} />
        </div>
    );
}
